import script from "./SelectComponent.vue?vue&type=script&setup=true&lang=js"
export * from "./SelectComponent.vue?vue&type=script&setup=true&lang=js"

import "./SelectComponent.vue?vue&type=style&index=0&id=6a0ca558&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6a0ca558"]])

export default __exports__